import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';

import Button from '../../Buttons/Button/Button';
import LabelFieldFormik from '../../Fields/LabelField/LabelFieldFormik';

import FormGrid from '../FormGrid/FormGrid';

import classes from './FormEdit.module.scss';

const FormEdit = ({ onAccept, schema, fields, backendValues, subtitle, initial, onChange }) => {
  const [fieldsState, setFieldsState] = useState(fields);

  const validationSquema = Yup.object().shape(schema);
  const setValue = (setFieldValue, key, value) => {
    if (key === 'department') {
      if (!!value.new) {
        setFieldValue('newDepartment', value);
      }
      setFieldValue(key, value.value);
    } else {
      setFieldValue(key, value);
      if (onChange) onChange(setFieldsState, setFieldValue, key, value);
    }
  };
  return (
    <Formik initialValues={backendValues || initial} validationSchema={validationSquema} onSubmit={onAccept} enableReinitialize>
      {({ setFieldValue, isSubmitting }) => (
        <Form className={classes.content}>
          <span className='bold-20'>Editar {subtitle}</span>
          <FormGrid
            className={classes.form}
            fields={fieldsState}
            onChange={(key, value) => setValue(setFieldValue, key, value)}
            Render={LabelFieldFormik}
          />
          <div className={classes.save}>
            <Button type='submit' custom='primary' disabled={isSubmitting}>
              Guardar cambios
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FormEdit;
